(function(win, szy) {
	
	let isGetUserInfo = false,
		ua = win.navigator.userAgent;
	szy.isIOS = /iPhone|iPad|iPod/i.test(ua);
	szy.isAndroid = /Android/i.test(ua);
	szy.isWechat = /MicroMessenger/i.test(ua);
	
	
	/**
	 * 请求服务器
	 * @param {String} api    接口
	 * @param {Object} data    传参 
	 * @param {String} type    请求方式  
	 * @param {Function} data    回调
	 * @param {Object} params  回调场景参数
	 * @param {Function} callSur  成功回调
	 * @param {Function} callErr  失败回调
	 * @param {Function} callTimeOut  超时回调
	 */
	let ajaxData = function(api, data, type, params, callSur, callErr, callTimeOut) {
		if(type == 'POST'){
			if($.isEmptyObject(data)){
				data = ""
			}else{
				data = JSON.stringify(data);
			}
		}
		
		$.ajax({
			type: type,
			url: api,
			data: data,
			dataType: "json",
			contentType: "application/json",
			async: true,
			success: function(json) {
				if(json.returncode == '10000') {
					if(params == null){
						callSur(json);
					}else{
						callSur(params, json);
					}
				} else {
					try {
						if(params == null){
							callErr(json);
						}else{
							callErr(params, json);
						}
					} catch(e) {}
				}
			},
			error: function(data) {
				if($(".mui-body-loading").length > 0){
					szy.closeLoading()
				}
				if(callTimeOut){
					callTimeOut();
					mui.toast('网络可能不给力，请求超时~');
					return
				}
				mui.toast('网络可能不给力，请稍后再试哦~');
			}
		});

	}


	/**
	 * 加载
	 */
	szy.loading = function(){
		$("body").append('<div class="mui-body-loading"><span class="mui-spinner"></span></div>');
	}
	
	/**
	 * 关闭加载
	 */
	szy.closeLoading = function(){
		$(".mui-body-loading").remove();
	}

    
	/**
	 * 微信分享API
	 * @param {Object} obj   参数
	 */
	szy.weixinShare = function(obj){
		if(!szy.isWechat){
			return false;
		}
		wx.config({
		    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
		    appId: obj.appId, // 必填，公众号的唯一标识
		    timestamp: obj.timestamp, // 必填，生成签名的时间戳
		    nonceStr: obj.nonceStr, // 必填，生成签名的随机串
		    signature: obj.signature,// 必填，签名
		    jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
		});
	
		if(obj.typeName == "share"){
			//调用分享
			wx.ready(function(){
		        //分享给朋友
		  		wx.onMenuShareAppMessage({
		  		    title: obj.shareTitle, // 分享标题
		  		    desc: obj.shareDesc, // 分享描述
		  		    link: obj.shareLink, // 分享链接
		  		    imgUrl: obj.shareImgUrl, // 分享图标
		  		    type: obj.shareType, // 分享类型,music、video或link，不填默认为link
		  		    dataUrl: obj.shareDataUrl // 如果type是music或video，则要提供数据链接，默认为空
		  		});
		  		//分享朋友圈
		  		wx.onMenuShareTimeline({
		  			title: obj.shareTitle,
		  		    link: obj.shareLink,
		  		    imgUrl: obj.shareImgUrl
		  		});
		  		
		  		wx.onMenuShareQQ({
		  			title: obj.shareTitle,
		  		    desc: obj.shareDesc,
		  		    link: obj.shareLink,
		  		    imgUrl: obj.shareImgUrl
		  		});
		  		
		  		wx.onMenuShareWeibo({
		  			title: obj.shareTitle,
		  		    desc: obj.shareDesc,
		  		    link: obj.shareLink,
		  		    imgUrl: obj.shareImgUrl
		  		});
		  		
		  		wx.onMenuShareQZone({
		  			title: obj.shareTitle,
		  		    desc: obj.shareDesc,
		  		    link: obj.shareLink,
		  		    imgUrl: obj.shareImgUrl
		  		});
		          
			});
		}
		
		wx.error(function(res){
		    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		});	
	}
	

	/**
	 * 获取上传图片token
	 */
	szy.upImgToken = function(callSur, callErr) {
		ajaxData(`${szyDocMain}/upload/getToken`, {}, 'POST', null, callSur, callErr)
	}
	
	
	/**
	 * 保存入园登录表
	 */
	szy.registerSave = function(data, callSur, callErr) {
		ajaxData(`${szyDocMain}/register/addRegisterStudentNew.action`, data, 'POST', null, callSur, callErr)
	}
	
	/**
	 * 获取字典
	 */
	szy.dictList = function(data, callSur, callErr) {
		ajaxData(`${szyDocMain}/dict/list`, data, 'POST', null, callSur, callErr)
	}
	
	/**
	 * 获取城市字典
	 */
	szy.dictCityList = function(data, callSur, callErr) {
		ajaxData(`${szyDocMain}/dict/list`, data, 'POST', null, callSur, callErr)
	}
	
	

})(window, window.szyApi || (window.szyApi = {}));